import { render, staticRenderFns } from "./AdminHeader.vue?vue&type=template&id=63780f44&scoped=true"
import script from "./AdminHeader.vue?vue&type=script&lang=js"
export * from "./AdminHeader.vue?vue&type=script&lang=js"
import style0 from "./AdminHeader.vue?vue&type=style&index=0&id=63780f44&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63780f44",
  null
  
)

export default component.exports